module.exports = __webpack_public_path__ + "static/media/cat-14.f46d5155.jpg";